module.exports = __webpack_public_path__ + "static/media/moon-flower.b6ce104c.jpg";